import {GeneralState} from "../general/general.reducer";
import {createReducer, on} from "@ngrx/store";
import {authActions} from "./action-types";

export interface AuthState {
  status: 'INITIAL' | 'CHECKING' | 'AUTHENTICATING' | 'AUTHENTICATED' | 'UNAUTHENTICATED';
  token: string | undefined;
  refreshToken: string | undefined;


  // employee: EmployeeDto | undefined;

  // profileDipendenteCompleted: boolean;
  // profileCompletedToOfferPass: boolean;

  // client: Client | undefined;
  // company: CompanyOutputDto | undefined;
}

export const initialState: AuthState = {
  status: 'INITIAL',
  token: undefined,
  refreshToken: undefined,
};

export const authReducer = createReducer(
  initialState,
  on(authActions.authenticatingCheck, (state)=> ({...state, status: 'CHECKING'})),
  on(authActions.authenticatingStart, (state)=>({...state, status: 'AUTHENTICATING'})),
  on(authActions.authenticatingEnd, (state, action)=>
    ({...state,
      token:action.token,
      refreshToken: action.refreshToken,
      status: 'AUTHENTICATED'
    }),

  ),
  on(authActions.authenticatingRefreshTokenEnd, (state, action)=>({...state, token: action.token, refreshToken: action.refreshToken})),
  on(authActions.authenticatingCheckFailed, (state)=>({...state, status: 'UNAUTHENTICATED'})),
  on(authActions.loggingOut, (state)=>({...state})),
  on(authActions.logOut, (state)=>({...state, status: 'UNAUTHENTICATED'})),
  on(authActions.logOutFailed, (state)=>({...state, status: 'UNAUTHENTICATED'})),
)
